export default __webpack_public_path__ + "static/media/Manufacturer name 2.69f62e17.png";